module.exports = new __parcel__URL__("banner-strand-right.7b45fab2.png").toString();